<form class="flexer padding no-top-padding">
  <textarea-input
    [title]="'Type product'"
    [placeholder]="'Geef hier het type van het product'"
    [initContent]="inputProduct.otherProductName"
    [disabled]="disabled"
    (answer)="otherProductNameChange($event)"
  ></textarea-input>

  <textarea-input
    [title]="'Materiaal'"
    [placeholder]="'Geef hier het materiaal van het product'"
    [initContent]="inputProduct.otherProductMaterial"
    [disabled]="disabled"
    (answer)="otherProductMaterialChange($event)"
  ></textarea-input>

  <textarea-input
    [placeholder]="'Extra info'"
    [initContent]="inputProduct.layoutDescription"
    [disabled]="disabled"
    (answer)="layoutDescriptionChange($event)"
  ></textarea-input>

  <div class="form-title">
    <div class="form-title-text">Afmetingen</div>
  </div>

  <div class="d-flex yop-space">
    <div class="first-form-field">
      <div class="size-label">Hoogte (in cm)</div>
      <mat-form-field appearance="outline">
        <input
          type="number"
          placeholder="Hoogte in cm"
          matInput
          [(ngModel)]="inputProduct.height"
          [disabled]="disabled"
          name="height"
          (ngModelChange)="heightChange($event)"
          required
        />
      </mat-form-field>
    </div>

    <div class="form-field">
      <div class="size-label">Breedte (in cm)</div>
      <mat-form-field appearance="outline">
        <input
          type="number"
          placeholder="Breedte in cm"
          matInput
          [(ngModel)]="inputProduct.width"
          [disabled]="disabled"
          name="width"
          (ngModelChange)="widthChange($event)"
          required
        />
      </mat-form-field>
    </div>
  </div>

  <design-picker
    *ngIf="!client && !fromOldSystem"
    [inputProduct]="inputProduct"
    [inputProject]="inputProject"
    [disabled]="disabled"
    (updateProduct)="outputOtherProduct.emit()"
  >
  </design-picker>
</form>
<internal-project-form
  *ngIf="!client && !fromOldSystem"
  [inputProject]="inputProject"
  [inputProduct]="inputProduct"
  [involvedCompanies]="involvedCompanies"
  [pmsColorAdded]="pmsColorAdded"
  (updateProduct)="outputOtherProduct.emit()"
></internal-project-form>
